import { useEffect, useState } from 'react';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { useLazyQuery } from '@apollo/client';
import { useTheme } from 'styled-components';
import { SectionItem, SectionLink } from '../components/Chrome';
import Global from '../components/Global';
import Loader from '../components/Loader';
import { Modal, ModalEditableName, ModalPart } from '../components/Modal';
import { SEARCH } from '../utilities/queries';

const SearchModal = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const [search, { loading, data }] = useLazyQuery(SEARCH);
  const [queryValue, setQueryValue] = useState('');
  const theme = useTheme();
  const [searchParams] = useSearchParams();

  if (!localStorage.getItem('token')) {
    navigate('/login', { state: { from: location }, replace: true });
  }

  useEffect(() => {
    if (queryValue.replace(/\s/g, '').length) {
      const delayDebounce = setTimeout(() => {
        search({
          variables: { text: queryValue, spaceSlug: params.s },
        });
      }, 500);

      return () => clearTimeout(delayDebounce);
    }
  }, [queryValue]);

  const close = () => {
    if (location.state?.backgroundLocation) {
      navigate(-1);
    } else {
      navigate(`/s/${params.s}`);
    }
  };

  return (
    <>
      <Global />
      <Modal onClose={() => close()}>
        <ModalEditableName
          value={queryValue}
          onChange={(e) => setQueryValue(e.target.value)}
          placeholder="Search topics..."
          type="text"
        />
        {loading ? (
          <ModalPart>
            <Loader />
          </ModalPart>
        ) : (
          <>
            {data?.search && (
              <>
                {data?.search.length !== 0 ? (
                  <>
                    {data.search.map((result) => (
                      <SectionLink
                        to={`/s/${location.state?.spaceSlug}/t/${result.publicId}`}
                        state={{
                          filters: {
                            authorId: searchParams.get('author'),
                            state: searchParams.get('state'),
                            assigneeId: searchParams.get('assignee'),
                            tagId: searchParams.get('tag'),
                          },
                        }}
                        style={{
                          padding: `${theme.space[2]} ${theme.space[6]}`,
                        }}
                      >
                        {result.name}
                      </SectionLink>
                    ))}
                  </>
                ) : (
                  <SectionItem
                    style={{ padding: `${theme.space[2]} ${theme.space[6]}` }}
                  >
                    No results found.
                  </SectionItem>
                )}
              </>
            )}
          </>
        )}
      </Modal>
    </>
  );
};

export default SearchModal;
